import MuiTypography from '@mui/material/Typography';
import { Stack, Box } from '@mui/system';
import dayjs from 'dayjs';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import _ from 'lodash';
import {
  Status,
  StatusDefault as StatusBooking,
} from '../../booking/conf/Data.conf';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import agency from '..';
import SwitchForm from '../../../components/operations/SwitchForm.component';
import RectangleChip from '../../../components/common/RectangleChip.component';
import { AgencyOptions } from './Data.conf';
import { Checkbox, Grid, Chip, Typography } from '@mui/material';
import { StatusOperationBookingType, StatusBilling } from '../../operations/conf/Data.conf';
import TextField from '../../../components/form/components/TextField.component';
import SelectCustom from '../../../components/form/components/SelectCustom.component';
import { API } from '../../operations/api';
import TemplateDelete from '../../../pages/templates/Delete.template';
import DuplicateTemplate from '../../../pages/duplicate/Duplicate.template';
import AgencyDrawerSendEmail from '../../../components/mexal/AgencyDrawerSendEmail.component';
import { SendEmailFormConf } from './SendEmailForm.conf';
import { API as agencyAPI } from '../api';
import { Link } from 'react-router-dom';
import AnchorIcon from '@mui/icons-material/Anchor';
import { IconButton, Tooltip } from '@mui/material';
import * as yup from 'yup';
import moment from 'moment';
import TimePickerComponent from '../../../components/form/components/TimePicker.component';

const ENABLE_TENDER_ISPS = [
  'BERTH RESERVATION',
  'BUOY RESERVATION',
  'AT ANCHOR',
  'BOOKED DIRECTLY',
];

const ENABLE_SEND_EMAIL_RESERVATION_TYPES = [
  'BERTH RESERVATION',
  'BUOY RESERVATION',
  'GARBAGE DISPOSAL',
  'PILOTS IN',
  'PILOTS OUT',
  'BUNKER',
];

const ENABLE_SEND_EMAIL_STATUSES = ['CONFIRMED', 'IN PROGRESS'];

const fmtDate = (d) => d ? dayjs(d).format('DD-MM-YYYY') : '-';
const fmtDateTime = (d) => d ? dayjs(d).format('DD-MM-YYYY HH:mm') : '-';

const getEmailData = (reservationType, value) => {

  const customRequest =
    reservationType === 'GARBAGE DISPOSAL'
      ? value?.operation_service || ''
      : value?.id_reservation?.data?.attributes?.id_arrival_departure_formality?.data?.attributes?.value ||
      '';

  return {
    mail_sended: value?.mail_sended ?? value?.attributes?.mail_sended,
    id: value?.id,
    custom_request: customRequest,
    id_yacht: value?.id_yacht?.data?.attributes?.yacht_name,
    yacht_type: value?.id_yacht?.data?.attributes?.yacht_type,
    email: value?.id_supplier?.data?.attributes?.email,
    loa: value?.id_yacht?.data?.attributes?.loa,
    beam: value?.id_yacht?.data?.attributes?.beam,
    draft: value?.id_yacht?.data?.attributes?.draft,
    gross_tonn: value?.id_yacht?.data?.attributes?.gross_tonn,
    //registry_type: value?.id_yacht?.data?.attributes?.registry_type,
    id_marina: value?.id_marina?.data?.attributes?.marina,
    check_in_date: fmtDateTime(value?.id_reservation?.data?.attributes?.check_in_date),
    check_out_date: fmtDateTime(value?.id_reservation?.data?.attributes?.check_out_date),
    requested_date: fmtDate(value?.requested_date),
    requested_dock: value?.id_reservation?.data?.attributes?.requested_dock,
    isps: value?.isps ?? false,
    tender: value?.tender ?? value?.tender_id ?? false,
    note: value?.note || '',
    payment_type: value?.id_reservation?.data?.attributes?.payment_type || '-',
    service_time: value?.id_reservation?.data?.attributes?.service_time,
    garbage_quantity: value?.id_reservation?.data?.attributes?.garbage_quantity,
    port: value?.id_reservation?.data?.attributes?.port,
    quantity_service_bunker: value?.id_reservation?.data?.attributes?.quantity_service_bunker,
    type_service_bunker: value?.id_reservation?.data?.attributes?.type_service_bunker,
    check_in_time: value?.id_reservation?.data?.attributes?.check_in_time,
    check_out_time: value?.id_reservation?.data?.attributes?.check_out_time,
    selling_price: value?.selling_price,
    purchase_price: value?.purchase_price,
    mexal_codice: value?.id_yacht?.data?.attributes?.id_attendance?.data[0]?.attributes?.mexal_code || '',
  };
};

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'requested_date',
      direction: 'asc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'checkbox_select',
      key: 'checkbox_select',
      sort_key: '',
      sortable: false,
      label: '',
      checkbox: true,
      width: 40,
      selectable: true,
    },
    {
      id: 'attributes.duplicate',
      key: 'duplicate',
      label: '',
      width: 1,
      checkbox: true,
    },
    {
      id: 'attributes.id_yacht.data',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'Yacht Name',
      width: '200px',
    },
    {
      id: 'attributes.status_operation_booking_id',
      key: 'status_operation_booking_id',
      sort_key: 'status_operation_booking',
      sortable: true,
      label: 'Operational Status',
      width: '140px',
      checkbox: true,
    },
    {
      id: 'attributes.reservation_type_id',
      key: 'reservation_type_id',
      sort_key: 'reservation_type',
      sortable: true,
      label: 'Service',
      width: '150px',
    },
    {
      id: 'attributes.operation_service',
      key: 'service',
      sort_key: 'operation_service',
      sortable: true,
      label: 'Service details',
      width: '170px',
    },
    {
      id: 'attributes.tender_id',
      key: 'tender_id',
      sort_key: 'tender',
      sortable: true,
      label: 'Tender',
      width: '10px',
      checkbox: true,
    },
    {
      id: 'attributes.isps_id',
      key: 'isps_id',
      sort_key: 'isps',
      sortable: true,
      label: 'ISPS',
      width: '10px',
      checkbox: true,
    },
    {
      id: 'attributes.requested_date',
      key: 'requested_date',
      sort_key: 'requested_date',
      sortable: true,
      label: 'Date',
      width: '140px',
    },
    {
      id: 'attributes.check_out_date',
      key: 'check_out_date',
      sort_key: 'check_out_date',
      sortable: true,
      label: 'Check out date',
      width: '140px',
    },
    {
      id: 'attributes.requested_hour_id',
      key: 'requested_hour_id',
      sort_key: 'requested_hour',
      sortable: true,
      label: 'Time',
      width: '100px',
      checkbox: true,
    },
    {
      id: 'attributes.id_marina.data.attributes.marina',
      key: 'id_marina',
      sort_key: 'id_marina.marina',
      sortable: true,
      label: 'Location',
      width: '160px',
    },
    {
      id: 'attributes.OC_fees_id',
      key: 'OC_fees_id',
      sort_key: 'OC_fees',
      sortable: true,
      label: 'Notes',
      width: "150px",
      checkbox: true,
    },
    {
      id: 'attributes.id_supplier.data.attributes.company_name',
      key: 'id_supplier',
      sort_key: 'id_supplier',
      sortable: true,
      label: 'Supplier',
      width: 180,
      checkbox: true,
    },
    {
      id: 'attributes',
      key: 'send_email',
      sortable: false,
      label: '',
      width: '0px',
      checkbox: true,
    },
    {
      id: 'attributes.OC_BC_number_id',
      key: 'OC_BC_number_id',
      sort_key: 'OC_BC_number',
      sortable: true,
      label: 'Sales Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.OF_BF_number_id',
      key: 'OF_BF_number_id',
      sort_key: 'OF_BF_number',
      sortable: true,
      label: 'Purchase Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.account_type',
      key: 'account_type',
      sort_key: 'account_type',
      sortable: true,
      label: 'CH/BOAT',
      width: '100px',
    },
    {
      id: 'attributes.status_billing_id',
      key: 'status_billing_id',
      sort_key: 'status_billing',
      sortable: true,
      label: 'Billing Status',
      width: '140px',
      checkbox: true,
    },
    {
      id: 'attributes.billing_notes_id',
      key: 'billing_notes_id',
      sort_key: 'billing_notes',
      sortable: true,
      label: 'Billing Notes',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes',
      key: 'delete',
      sortable: false,
      label: '',
      width: '0px',
      checkbox: true,
    },
  ],
  render: {
    formatHead: (key, value, { isChecked, indeterminate }) => {
      switch (key) {
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              indeterminate={indeterminate}
            />
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick, isChecked) => {
      switch (key) {
        case 'status_operation_booking_id':
          const color = _.find(
            Status,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_operation_booking?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_operation_booking: value?.status_operation_booking,
              }}
              name={'status_operation_booking'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_operation_booking'
                    name='status_operation_booking'
                    label='Operational Status'
                    options={
                      value?.status_operation_booking === 'BOOKED DIRECTLY' ||
                        value?.status_operation_booking === 'AT ANCHOR'
                        ? StatusBooking
                        : StatusOperationBookingType
                    }
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_operation_booking ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_operation_booking}
                    backgroundColor={color?.hex}
                    color='#fff'
                    width={150}
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );

        case 'yacht_name': {
          const attendance = value?.attributes?.id_attendance?.data?.[0]?.attributes;
          const provenence =
            attendance?.id_provenence_list?.data?.attributes?.provenence?.data
              ?.attributes?.provenence ||
            value?.attributes?.provenence;
          const mexalCode = attendance?.mexal_code || '-';
          const mexalResearchName = attendance?.mexal_research_name || '-';
          const mexalTooltip = [mexalCode, mexalResearchName]
            .filter((item) => item && item !== '-')
            .join(' - ');

          return (
            <Tooltip
              title={mexalTooltip || ''}
            >
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                spacing={1}
              >
                <Stack direction={'column'} spacing={0.5}>
                  <MuiTypography
                    variant='body1'
                    sx={{ fontWeight: 'bold' }}
                    onClick={onClick}
                  >
                    {value?.attributes?.yacht_name || '-'}
                  </MuiTypography>
                  {provenence && (
                    <MuiTypography
                      variant='caption'
                      color='text.secondary'
                      onClick={onClick}
                    >
                      {provenence}
                    </MuiTypography>
                  )}
                  <Chip
                    label={`#${value?.id || '-'}`}
                    size="small"
                    sx={{ width: 'fit-content', alignSelf: 'flex-start' }}
                  />
                </Stack>
              </Stack>
            </Tooltip>
          );
        }
        case 'check_out_date':
        case 'requested_date': {
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value ? dayjs(value).format('DD-MM-YYYY') : '-'}
              </MuiTypography>
            </Stack>
          );
        }
        case 'requested_hour_id': {
          return (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              name={'requested_hour'}
              defaultValues={{
                requested_hour: value?.requested_hour,
              }}
              schema={yup.object({
                requested_hour: yup
                  .string()
                  .nullable()
                  .test('is-time', 'Time format invalid', (hourValue) => {
                    if (!hourValue) return true;
                    return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(
                      hourValue
                    );
                  }),
              })}
              form={
                <TimePickerComponent
                  name={'requested_hour'}
                  value={value?.requested_hour}
                />
              }
            >
              {value?.requested_hour ? (
                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                  {value?.requested_hour ? (
                    <>
                      <AccessTimeIcon color='action' />
                      <MuiTypography
                        sx={{ fontWeight: 'bold', height: 1 }}
                        variant='body1'
                        onClick={onClick}
                      >
                        {moment(
                          value?.requested_hour,
                          'HH:mm:ss'
                        ).format('HH:mm')}
                      </MuiTypography>
                    </>
                  ) : (
                    '-'
                  )}
                </Stack>
              ) : (
                <MuiTypography
                  variant='body1'
                  onClick={onClick}
                  sx={{ height: '100%' }}
                >
                  -
                </MuiTypography>
              )}
            </TableCellEdit>
          );
        }
        case 'name': {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <PersonIcon color='action' fontSize='small' />
              <MuiTypography
                sx={{ height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {`${value?.name} ${value?.surname}`}
              </MuiTypography>
            </Stack>
          ) : (
            '-'
          );
        }
        case 'status_billing_id':
          const colorBilling = _.find(
            StatusBilling,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_billing?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_billing: value?.status_billing,
              }}
              name={'status_billing'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_billing'
                    name='status_billing'
                    label='Billing Status'
                    options={StatusBilling}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_billing ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_billing}
                    backgroundColor={colorBilling?.hex}
                    color={colorBilling?.textHex}
                    width={150}
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );

        case 'billing_notes_id':
          return (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ billing_notes: value?.billing_notes }}
              value={value}
              name={'billing_notes'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='billing_notes'
                    name='billing_notes'
                    label='Billing Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.billing_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'OC_BC_number_id':
          return (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_BC_number: value?.OC_BC_number }}
              value={value}
              name={'OC_BC_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_BC_number'
                    name='OC_BC_number'
                    label='Sales Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_BC_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );

        case 'OF_BF_number_id':
          return (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OF_BF_number: value?.OF_BF_number }}
              value={value}
              name={'OF_BF_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OF_BF_number'
                    name='OF_BF_number'
                    label='Purchase Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OF_BF_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'OC_fees_id':
          return (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_fees: value?.OC_fees }}
              value={value}
              name={'OC_fees'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_fees'
                    name='OC_fees'
                    label='Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_fees || '-'}
              </MuiTypography>
            </TableCellEdit>
          );

        case 'reservation_type_id':
          const reservationColor = _.find(
            AgencyOptions,
            (item) => item?.id === value?.reservation_type
          )?.color;

          return value?.reservation_type ? (
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              spacing={1}>
              <RectangleChip
                value={value?.reservation_type}
                width={'auto'}
                backgroundColor={reservationColor}
                color='#fff'
              />
              {value?.booking ?
                <IconButton
                  component={Link}
                  to={`/booking/${value?.booking?.id}`}
                  aria-label="Prenotazioni porto"
                  color="secondary"
                  size="small"
                  target="_blank"
                  onClick={(event) => event.stopPropagation()}
                >
                  <Tooltip title={`${value?.booking?.attributes?.id_marina?.data?.attributes?.marina || ''} (${dayjs(value?.booking?.attributes?.check_in_date).format('DD-MM-YYYY HH:mm')} / ${dayjs(value.booking?.attributes?.check_out_date).format('DD-MM-YYYY HH:mm')})`}>
                    <AnchorIcon />
                  </Tooltip>
                </IconButton>
                : null}
            </Stack>
          ) : (
            '-'
          );
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              disabled={onClick ? false : true}
            />
          );
        case 'tender_id':
          return !!_.find(
            ENABLE_TENDER_ISPS,
            (item) => item === value?.reservation_type
          ) ? (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              name={'tender'}
              defaultValues={{ tender: value?.tender }}
              form={<SwitchForm value={value} name={'tender'} />}
              width={100}
            >
              {!!value?.tender ? (
                <CheckCircleIcon color='success' />
              ) : value?.tender === null ? (
                <MuiTypography
                  variant='body1'
                  onClick={onClick}
                  sx={{ height: '100%' }}
                >
                  {'-'}
                </MuiTypography>
              ) : (
                <CancelIcon color='error' />
              )}
            </TableCellEdit>
          ) : (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {'-'}
            </MuiTypography>
          );
        case 'isps_id':
          return !!_.find(
            ENABLE_TENDER_ISPS,
            (item) => item === value?.reservation_type
          ) ? (
            <TableCellEdit
              module={{
                ...agency,
                query: {
                  ...agency.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              name={'isps'}
              defaultValues={{ isps: value?.isps }}
              form={<SwitchForm value={value} name={'isps'} />}
              width={100}
            >
              {!!value?.isps ? (
                <CheckCircleIcon color='success' />
              ) : value?.isps === null ? (
                <MuiTypography
                  variant='body1'
                  onClick={onClick}
                  sx={{ height: '100%' }}
                >
                  {'-'}
                </MuiTypography>
              ) : (
                <CancelIcon color='error' />
              )}
            </TableCellEdit>
          ) : (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {'-'}
            </MuiTypography>
          );

        case 'send_email': {
          const reservationType = value?.reservation_type_id?.reservation_type;
          const operationStatus = value?.status_operation_booking;
          const canShowSendEmail =
            ENABLE_SEND_EMAIL_RESERVATION_TYPES.includes(
              reservationType?.toUpperCase?.()
            ) &&
            ENABLE_SEND_EMAIL_STATUSES.includes(
              operationStatus?.toUpperCase?.()
            );

          if (!canShowSendEmail) {
            return null;
          }

          const emailConf = SendEmailFormConf[reservationType];
          const emailData = getEmailData(reservationType, value);
          return (
            <AgencyDrawerSendEmail
              id={value?.id}
              conf={emailConf}
              data={emailData}
              tag='AGENCY'
              sendEmailApi={agencyAPI.sendEmail}
              idKey='id_operation'
              tooltip='The reservation data displayed is read-only. It is possible to enter a different email address (the email will not be saved). All data can be edited in the EDIT form.'
              showMailSendedFeedback={true}
            />
          );
        }
        case 'delete':
          return (
            <TemplateDelete module={agency} idDelete={value?.id} isIcon>
              {value?.id_reservation?.data?.attributes?.reservation_type && (
                <Typography component='div' mt={1}>
                  The
                  <Box fontWeight={'bold'} display='inline'>
                    {` ${value?.id_reservation?.data?.attributes?.reservation_type} `}
                  </Box>
                  type reservation will also be deleted.
                </Typography>
              )}
            </TemplateDelete>
          );
        case 'duplicate':
          return <DuplicateTemplate module={agency} data={value} isIcon />;
        default:
          return (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
